module.exports = __webpack_public_path__ + "img/moulinette_home_illusatration.a21ac648.jpg";